import { useComposeStore } from '@/stores/compose';
import { TypeSheet } from './TypeSheet';
import { TransactionModal } from './TransactionModal';

/**
 * Monta as superfícies de lançamento uma única vez (AppShell) e as conecta ao
 * useComposeStore, para que FAB, cards de conta e a lista possam abri-las.
 */
export function TransactionComposer() {
  const typeSheet = useComposeStore((s) => s.typeSheet);
  const modal = useComposeStore((s) => s.modal);
  const closeTypeSheet = useComposeStore((s) => s.closeTypeSheet);
  const openNew = useComposeStore((s) => s.openNew);
  const openCardExpense = useComposeStore((s) => s.openCardExpense);
  const closeModal = useComposeStore((s) => s.closeModal);

  return (
    <>
      <TypeSheet
        open={typeSheet.open}
        anchor={typeSheet.anchor}
        onClose={closeTypeSheet}
        onPick={(type) => (type === 'card' ? openCardExpense() : openNew(type))}
      />
      <TransactionModal
        open={modal.open}
        type={modal.type}
        editing={modal.editing}
        presetAccountId={modal.presetAccountId}
        isCard={modal.isCard}
        presetCardId={modal.presetCardId}
        onClose={closeModal}
      />
    </>
  );
}
